(() => {
  const chat = document.querySelector('shopify-chat');
  if (!chat) return;
  const mobile = matchMedia('(max-width: 767px)');
  let frame = 0;
  let lift = 0;
  const observed = new Set();
  const roots = new WeakSet();
  const sizes = new ResizeObserver(() => schedule());
  const selectors = '.cart__ctas, .cart__additional-checkout-buttons, button[name="add"], .shopify-payment-button, .sticky-add-to-cart, .rxk-addon-item, .rxk-swatch, .cart-items__price, .quantity-selector, [data-rxk-reservation-notice], main h1, variant-picker, .rxk-case-guide, .rxk-ct-titel, product-card [ref="productTitleLink"] .text-block, product-card product-price';
  const update = () => {
    frame = 0;
    const runtime = chat.shadowRoot?.querySelector('shopify-agent-runtime')?.shadowRoot;
    if (runtime && !roots.has(runtime)) {
      roots.add(runtime);
      new MutationObserver(schedule).observe(runtime, {childList: true, subtree: true});
    }
    const launcher = chat.shadowRoot?.querySelector('[part~="activator"]') || runtime?.querySelector('[part~="activator"]');
    if (!launcher) return;
    let next = 0;
    let blocked = false;
    if (!chat.hasAttribute('open')) {
      const box = launcher.getBoundingClientRect();
      const base = {left: box.left, right: box.right, top: box.top + lift, bottom: box.bottom + lift};
      const sliderControls = 'body.rxk-tpl-slider media-gallery slideshow-arrows, body.rxk-tpl-slider .rxk-ct, body.rxk-tpl-slider .rxk-kurz';
      const privacyControls = '.rxk-fuss__recht, a[href="#shopifyReshowConsentBanner"], a[href*="/policies/privacy-policy"], a[href*="/pages/data-sharing-opt-out"], #shopify-pc__banner, #shopify-pc__prefs__dialog';
      const protectProduct = mobile.matches || document.body.classList.contains('rxk-tpl-slider');
      const elements = [...document.querySelectorAll(protectProduct ? `${selectors}, ${sliderControls}, ${privacyControls}` : privacyControls)];
      for (const element of observed) {
        if (!element.isConnected) { sizes.unobserve(element); observed.delete(element); }
      }
      for (const element of elements) {
        if (!observed.has(element)) { sizes.observe(element); observed.add(element); }
      }
      const targets = elements.filter(e => e.checkVisibility()).map(e => e.getBoundingClientRect());
      for (let pass = 0; pass <= targets.length; pass++) {
        let moved = false;
        for (const rect of targets) {
          if (rect.width && rect.height && rect.bottom > 0 && rect.top < innerHeight && base.right > rect.left && base.left < rect.right && base.bottom - next > rect.top - 12 && base.top - next < rect.bottom + 12) {
            next = base.bottom - rect.top + 12;
            moved = true;
          }
        }
        if (!moved) break;
      }
      blocked = base.top - next < 100;
    }
    lift = Math.max(0, next);
    chat.style.setProperty('--rxk-chat-lift', `${lift}px`);
    chat.toggleAttribute('data-rxk-no-chat-space', blocked);
  };
  const schedule = () => { if (!frame) frame = requestAnimationFrame(update); };
  addEventListener('scroll', schedule, {passive: true, capture: true});
  addEventListener('resize', schedule, {passive: true});
  mobile.addEventListener('change', schedule);
  window.visualViewport?.addEventListener('resize', schedule);
  new MutationObserver(schedule).observe(document.body, {childList: true, subtree: true});
  new MutationObserver(schedule).observe(chat, {attributes: true, attributeFilter: ['open', 'mode']});
  customElements.whenDefined('shopify-chat').then(() => {
    if (chat.shadowRoot) new MutationObserver(schedule).observe(chat.shadowRoot, {childList: true, subtree: true});
    schedule();
  });
  customElements.whenDefined('shopify-agent-runtime').then(schedule);
})();
